import { useMemo } from 'react'

import ApplePayIcon from '@/components/icons/apple-pay.svg?react'
import CreditCardIcon from '@/components/icons/credit-card.svg?react'
import GooglePayIcon from '@/components/icons/google-pay.svg?react'

import { OptionCard } from './OptionCard'

interface Props {
  selectedPaymentMethod: string
  onSelectPaymentMethod: (method: string) => void
}

export const PaymentOptions = ({ selectedPaymentMethod, onSelectPaymentMethod }: Props) => {
  const isSafari = useMemo(() => {
    const userAgentString = navigator.userAgent
    const chromeAgent = userAgentString.indexOf('Chrome') > -1
    let safariAgent = userAgentString.indexOf('Safari') > -1
    if (chromeAgent && safariAgent) safariAgent = false
    return safariAgent
  }, [])

  return (
    <div className='space-y-4'>
      <h3 className='text-text-primary text-sm font-medium'>אפשרויות תשלום</h3>
      <OptionCard
        onSelect={() => onSelectPaymentMethod('creditCard')}
        selected={selectedPaymentMethod === 'creditCard'}
        title='כרטיס אשראי'
        endContent={<CreditCardIcon />}
      />
      <OptionCard
        onSelect={() => onSelectPaymentMethod('google')}
        selected={selectedPaymentMethod === 'google'}
        title='Google Pay'
        endContent={<GooglePayIcon />}
      />
      {isSafari && (
        <OptionCard
          className='flex h-[58px] items-center'
          onSelect={() => onSelectPaymentMethod('apple')}
          selected={selectedPaymentMethod === 'apple'}
          title='Apple Pay'
          endContent={<ApplePayIcon className='w-9' />}
        />
      )}
    </div>
  )
}
